const firebaseConfig = {
    apiKey: "AIzaSyAo-K6Bu5E89nQot-i72jBkyQN7dPTSLpU",
    authDomain: "hotel-transylvania-e51e7.firebaseapp.com",
    projectId: "hotel-transylvania-e51e7",
    storageBucket: "hotel-transylvania-e51e7.appspot.com",
    messagingSenderId: "618690754649",
    appId: "1:618690754649:web:c11841458d4f929221d948"
  };
  export default firebaseConfig;